import { render, staticRenderFns } from "./InformativeAC.vue?vue&type=template&id=5c0404f6&scoped=true"
import script from "./InformativeAC.vue?vue&type=script&lang=js"
export * from "./InformativeAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0404f6",
  null
  
)

export default component.exports